module.exports = __webpack_public_path__ + "img/CHEVRON_LEFT.20f787ba.svg";